import * as React from 'react';
import { Notify } from '@shared/ui-native/Notify';
import { Events } from '@shared/Events';
import { cs } from '@shared/utils/utils-classname';
import { DateTimeSpan } from '@shared/ui-react/UtilComponents';
import './FileHistory.scss';
import { FilesService } from '@shared/services/FilesService';


export class FileHistory extends React.Component<{
    fileId: number,
    readOnly?: boolean
}, {
    activeVersion?: number,
    versions?: any[],
    isLoading?: boolean
}> {

    state = {
        activeVersion: 0,
        versions: [],
        isLoading: true,
    };

    componentDidMount() {
        this.fetch(this.props.fileId);
    }

    render() {
        const { readOnly } = this.props;
        const canDownload = kuura.hasPrivilege('Download_Model');

        return (
            <div className={cs({ 'overlay-loading': this.state.isLoading })} style={{ minHeight: 200 }}>
                {this.state.versions.map((item, index) =>
                    (<section className='file-history-line' key={item.id}>
                        <header>
                            {canDownload && <div className='version-number'><strong>{kuura.getMessage('js_files.version')}: {item.version + 1}</strong>
                                &nbsp;&nbsp;<a href={'/kuura/api/1/file/' + item.id + '/get'} target='_blank'><i
                                    className='iki iki-download'></i></a>
                            </div>
                            }
                            <div className='version-status'>
                                {item.version === this.state.activeVersion ?
                                    <div className='version-active'>{kuura.getMessage('js_files.active_version')}</div> :
                                    ( readOnly ? null : <button onClick={this.setActive.bind(this, item.id)}>{kuura.getMessage('js_files.set_as_active_version')}</button> )
                                }
                            </div>
                        </header>
                        <footer>
                            <div>{item.name} ({item.filesizeString})</div>
                            <div>{kuura.getMessage('general.creation_time')}: <DateTimeSpan
                                timestamp={item.timestamp}/> ({item.lastModifiedUser})
                            </div>
                            <div>{item.description}</div>
                        </footer>
                    </section>),
                )}
                <div id="modelIdElement" style={{ display: 'none' }}>{this.props.fileId}</div>
            </div>

        );
    }

    fetch(fileId: number) {
        this.setState({ isLoading: true });
        return FilesService.getVersions(fileId)
                    .always(() => this.setState({ isLoading: false }))
                    .done((resp: any) => this.setState({ activeVersion: resp.activeVersion, versions: resp.modelVersions }));
    }

    setActive(modelId: number) {
        this.setState({ isLoading: true });

        FilesService.setActiveVersion(modelId)
             .always(() => this.setState({ isLoading: false }))
             .done(() => {
                 Notify.success();
                 Events.trigger('explorer_items_changed');
                 this.fetch(this.props.fileId);
             });
    }
}
